import { render, staticRenderFns } from "./PageMassMessage.vue?vue&type=template&id=25cadef3&"
import script from "./PageMassMessage.vue?vue&type=script&lang=js&"
export * from "./PageMassMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports